// Custom Scripts
import '../js/blueprint';

// Instant Page
import 'instant.page';

// GSAP
import { gsap } from 'gsap';

window.gsap = gsap;

// Alpine
import Alpine from 'alpinejs';

import registerPlugins from '../alpine/plugins';
import registerStores from '../js/stores';
import registerData from '../js/data';

registerPlugins(Alpine);
registerStores(Alpine);
registerData(Alpine);

window.Alpine = Alpine;

Alpine.start();
